import { useEffect, useCallback } from "react";
import Lenis from "lenis";
import "@/App.css";
import Nav from "./components/Nav";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import About from "./components/About";
import Services from "./components/Services";
import RateSheet from "./components/RateSheet";
import WhyUs from "./components/WhyUs";
import StatsBand from "./components/StatsBand";
import Founder from "./components/Founder";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import WhatsAppFloat from "./components/WhatsAppFloat";
import AvatarBubble from "./components/AvatarBubble";
import { initAnalytics } from "./lib/analytics";

function App() {
  useEffect(() => {
    initAnalytics();
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  const scrollTo = useCallback((href) => {
    const el = document.querySelector(href);
    if (!el) return;
    if (window.__lenis) window.__lenis.scrollTo(el, { offset: -76, duration: 1.4 });
    else el.scrollIntoView({ behavior: "smooth" });
  }, []);

  return (
    <div className="relative min-h-screen bg-paper text-ink font-sans overflow-x-clip">
      <div className="noise-overlay fixed inset-0 z-[5] opacity-50" aria-hidden="true" />
      <Nav onNav={scrollTo} />
      <main className="relative z-10">
        <Hero onNav={scrollTo} />
        <Marquee />
        <About />
        <Services />
        <RateSheet />
        <WhyUs />
        <StatsBand />
        <Founder />
        <Contact />
      </main>
      <Footer onNav={scrollTo} />
      <WhatsAppFloat />
      <AvatarBubble />
    </div>
  );
}

export default App;
